import loadable from '@loadable/component'

export const LazySwmPlayerProvider = loadable(() =>
    import('./SwmPlayerProvider'),
)
